import React from "react";
import styled from "styled-components";

import Title from "../title";
import Article from "../article";

const ServiceSectionContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    background-color: #ffffff;
    clip-path: polygon(100px 0, 100% 0, 100% calc(100% - 100px), calc(100% - 100px) 100%, 0 100%, 0 100px);
    margin-top: -150px;
    box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.75);
    border: 6px solid #fafafa;
    padding-top: 50px;
    padding-bottom: 70px;
    position: absolute;
    top: 0;
    z-index: 99;
`;

const ServicesContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 100%;
    max-width: 1080px;
    margin-top: 50px;
`;

const Service = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 100%;
`;

const ServiceImageContainer = styled.div`
    height: 240px;
    width: 240px;
    clip-path: polygon(50px 0, 100% 0, 100% calc(100% - 50px), calc(100% - 50px) 100%, 0 100%, 0 50px);
    box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.75);
`;

const ServiceImage = styled.img`
    height: 100%;
    width: 100%;
`;

const ServiceTitle = styled.h2`
    font-size: 1rem;
    color: #666666;
    font-family: 'Montserrat';
    font-weight: 600;
    line-height: 20px;
    margin-top: 15px;
    text-transform: uppercase;
    padding: 0 60px;
`;

const ServiceItem = ({ image, title }) => {
    return (
        <Service>
            <ServiceImageContainer>
                <ServiceImage src={image} />
            </ServiceImageContainer>
            <ServiceTitle>
                {title}
            </ServiceTitle>
        </Service>
    );
}

const ServiceSection = () => {
    return (
        <div style={{
            position: 'relative',
            width: '100%',
            height: '460px'
        }}>
            <ServiceSectionContainer>
                <Title text={'Services'} />
                <Article>
                    Transferts aéroport-stations de ski en VTC :<br/>
                    confort, sécurité et service sur-mesure pour un voyage serein.
                </Article>
                <ServicesContainer>
                    <ServiceItem 
                        image={require('../../../assets/images/service-evenementiel.png')} 
                        title={'Transport Evenementiel'} 
                    />
                    <ServiceItem 
                        image={require('../../../assets/images/service-personnel.png')} 
                        title={'Personnel à disposition'} 
                    />
                    <ServiceItem 
                        image={require('../../../assets/images/service-custom-path.png')} 
                        title={'Excursions sur-mesure'} 
                    />
                    <ServiceItem 
                        image={require('../../../assets/images/service-vip.png')} 
                        title={'Transfers VIP'} 
                    />
                </ServicesContainer>
            </ServiceSectionContainer>
        </div>
    );
}

export default ServiceSection;